import axios from 'axios'
import { getResponseData } from 'src/queries/network.utils'
import { CardManagementCapabilitiesResponse } from 'src/queries/physicalCardManagement/physicalCardManagement.models'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'

// Pure network function for the Card Management capabilities read. Mirrors the
// backend route exactly; getRequestConfig(RequestConfig.Default) supplies the
// authed-json config and getResponseData throws a normalized QueryError.
export const fetchCardManagementCapabilities = async (
  organizationId: string,
  creditCardId: string,
): Promise<CardManagementCapabilitiesResponse> =>
  getResponseData(
    axios.get<CardManagementCapabilitiesResponse>(
      `/organizations/${organizationId}/physicalcards/${creditCardId}/cardmanagement/capabilities`,
      getRequestConfig(RequestConfig.Default),
    ),
  )
